<template>
  <div class="shangquanMapPage">
    <div class="xr-mingxi">        
      <mu-appbar class="xr-head" title="商家地址">
        <mu-icon-button icon=":fa fa-angle-left" slot="left" @click="GoHistory()" />
        <!-- <mu-icon value=":fa fa-zhuanfa"  slot="right"/> -->
      </mu-appbar>
    </div>
    
    <div title="单击获取点击的经纬度" id="allmap" :style="{width:'100%', height:fullHeight+'px'}"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      latitude: this.$route.query.latitude,
      longitude : this.$route.query.longitude,
      fullHeight: document.documentElement.clientHeight - 56
    }
  },
  mounted() {
     this.InitMap()     
  },
  methods: {  
    GoHistory(){
      this.$router.goBack()
    },
    InitMap(){
      var map = new BMap.Map("allmap", { mapType: BMAP_NORMAL_MAP });      
      var point = new BMap.Point(this.longitude, this.latitude);    // 创建点坐标 
      map.centerAndZoom(point, 18);             // 初始化地图,设置中心点坐标和地图级别。  
      map.addControl(new BMap.NavigationControl());
      map.enableScrollWheelZoom();                  // 启用滚轮放大缩小。  
      map.enableKeyboard();                         // 启用键盘操作。
      map.setDefaultCursor("crosshair");   //设置地图默认的鼠标指针样式        
      //初始选定值
      map.clearOverlays();
        var icon = new BMap.Icon('/static/map/ancher-1.png', new BMap.Size(20, 32), {
            anchor: new BMap.Size(10, 30)
        });
        var mkr = new BMap.Marker(new BMap.Point(this.longitude, this.latitude), {
            icon: icon
        });
        map.addOverlay(mkr);
    }  
  },
  computed: {
    
  }
};
</script>
<style>
.shangquanMapPage .xr-mingxi{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanMapPage .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shangquanMapPage .xr-mingxi .mu-appbar{
  background-color: #fff;
  color: #000;
}
.xr-mingxi .xr-head .mu-icon{
  color: #aaa;
}
.xr-mingxi .xr-head .fa-xing1{
  font-size: 24px;
  width: 28px;
  margin-right: 5px;
  padding-bottom: 5px;
}
.shangquanMapPage .xr-mingxi .mu-appbar-title {
    font-size: 16px;
    text-align: center;
}
.shangquanMapPage .xr-mingxi .left .mu-icon-button {
    color:white;
}
.shangquanMapPage .xr-mingxi .title .title-text {
    margin: 0;
    line-height: 48px;
}
.shangquanMapPage .xr-mingxi .mu-paper-1{
    box-shadow: none;
}
.shangquanMapPage .mu-list{
  background: #fff;
  padding-bottom: 0;
}
.shangquanMapPage .mu-list .zhizhao{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanMapPage .mu-list .mu-item.show-left{
  padding-left: 50px;
}
.shangquanMapPage .mu-list .item-img img{
  width: 100%;
}
.shangquanMapPage .dianpu .item-img .mu-item{
  padding-bottom: 0;
}
.shangquanMapPage .dianpu .item-img:last-child .mu-item{
  padding-bottom: 16px;
}
.shangquanMapPage .xr-mingxi .right{
    width: 48px;
    font-size: 16px;
    text-align: center;
}
.shangquanMapPage .xr-mingxi .right .fa-zhuanfa{
    width: 48px;
    font-size: 24px;
}
</style>




// WEBPACK FOOTER //
// src/pages/shangquan/sqMap.vue